const skillsFullstack = [
    {
        id: "wdc001",
        title: "Laravel Blade"
    },
    {
        id: "wdc002",
        title: "MERN"
    },
    {
        id: "wdc003",
        title: "MERN + G"
    }
]

export default skillsFullstack;
